/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { bignumberDependencies } from './dependenciesBignumber.generated';
import { fractionDependencies } from './dependenciesFraction.generated';
import { addDependencies } from './dependenciesAdd.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createSum } from '../../factoriesAny.js';
export var sumDependencies = {
  bignumberDependencies: bignumberDependencies,
  fractionDependencies: fractionDependencies,
  addDependencies: addDependencies,
  typedDependencies: typedDependencies,
  createSum: createSum
};